import styled from "styled-components";
import { CSSObject } from "styled-components";
import Box from "../../layout/boxes/Box";
import { colorMapping } from "./Icon";
import { IconBorderRadii, IconSizes, StyledIconProps } from "./Icon.types";

export const iconSizeMapping: IconSizes = {
	xs: "12px",
	sm: "16px",
	md: "24px",
	lg: "32px",
	xl: "48px",
	xxl: "60px",
};

const filledIconSizeMapping: IconSizes = {
	xs: "24px",
	sm: "32px",
	md: "48px",
	lg: "64px",
	xl: "96px",
	xxl: "128px",
};

const borderRadiusMapping: IconBorderRadii = {
	xs: "sm",
	sm: "md",
	md: "lg",
	lg: "xl",
	xl: "xxl",
	xxl: "xxxl",
};

const StyledIcon = styled(({ size, ...props }: StyledIconProps) => (
	<Box {...props} />
))<StyledIconProps>`
	@keyframes slingshot-up {
		0% {
			transform: translateY(0px);
		}
		30% {
			transform: translateY(7px);
		}
		60% {
			transform: translateY(-35px);
		}
		60.1% {
			transform: translateY(35px);
		}
		100% {
			transform: translateY(0px);
		}
	}

	@keyframes slingshot-down {
		0% {
			transform: translateY(0px);
		}
		30% {
			transform: translateY(-7px);
		}
		60% {
			transform: translateY(35px);
		}
		60.1% {
			transform: translateY(-35px);
		}
		100% {
			transform: translateY(0px);
		}
	}

	${({ size = "md", color, theme, variant }) => {
		const SIZE = iconSizeMapping[size];
		const CONTAINED_SIZE = filledIconSizeMapping[size];

		const DEFAULT_STYLING: CSSObject = {
			height: SIZE,
			width: SIZE,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			boxSizing: "border-box",
			clipPath: "circle(100% at 50% 50%)",

			svg: {
				width: SIZE,
				height: SIZE,
			},
		};

		const CONTAINED_STYLING: CSSObject = {
			height: CONTAINED_SIZE,
			width: CONTAINED_SIZE,
			backgroundColor: theme.palette.hexFor(colorMapping[color]),
			borderRadius: theme.radii[borderRadiusMapping[size]],
			clipPath: "circle(50% at 50% 50%)",

			svg: {
				width: SIZE,
				height: SIZE,
			},
		};

		if (variant === "icon-only") {
			return DEFAULT_STYLING;
		}

		if (variant === "filled") {
			return { ...DEFAULT_STYLING, ...CONTAINED_STYLING };
		}
	}}
`;

export default StyledIcon;
